module.exports = require('./src/index');


//////////////////
// WEBPACK FOOTER
// ./node_modules/my-element-mixins/index.js
// module id = pgi9
// module chunks = 37